<label><span [ghs-label]="'settings.' + setting()"></span></label>
@if (sync()) {
  <div class="hint-container">
    @if (settingsManager.settings.serverSettings) {
      <img src="./assets/images/sync-settings.svg" class="hint-trigger ghs-svg sync-settings" />
    }
    <span class="hint">
      <span class="text" [ghs-label]="'settings.synced'"></span>
    </span>
  </div>
}
